// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3sc4l","head":"Table_head__3hmWe","col":"Table_col__2lyxX"};